// extracted by mini-css-extract-plugin
module.exports = {"container":"StandardIntro_container__NpGoK","logoContainer":"StandardIntro_logoContainer___lg_B","categoryContainer":"StandardIntro_categoryContainer__euj3R"};